// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { CredentialBilling } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Model/Billing';
import {
  ERR_FLUSH_EXPIRED_CRED_BILL,
  SUC_FLUSH_EXPIRED_CRED_BILL,
} from '../../../../utils/strings';

const useFlushExpiredCredentialBilling = () => {
  const { submit } = useExerciseSubmission(
    CredentialBilling.CredentialBilling_FlushExpiredDeposit,
    SUC_FLUSH_EXPIRED_CRED_BILL,
    ERR_FLUSH_EXPIRED_CRED_BILL,
  );

  return submit;
};

export default useFlushExpiredCredentialBilling;
